<template>
  <!-- 新闻动态 -->
  <div>
    <div class="content">
      <div class="new-detail">
        <div class="detail-back">
          <i class="el-icon-back" @click="goBack"></i>
          <div class="detail-text">服务支持</div>
        </div>
      </div>

      <div class="content-title">{{ config.title }}</div>
      <div class="content-desc">{{ config.desc }}</div>
      <!-- 奖项认可prizeTitle -->
      <div class="prize">
        <div class="prize-title">{{ config.prizeTitle }}</div>
        <div class="prize-list">
          <div class="prize-item" v-for="(item, index) in config.prizeList" :key="index">
            <el-image class="prize-img" :src="item.src" fit="cover"></el-image>
            <div class="prize-item-title" @click="pageToDetail(item)">{{ item.title }}</div>
            <div class="prize-item-desc">{{ item.info }}</div>
            <div class="prize-item-date">{{ item.date }}</div>
          </div>
          <div class="prize-desc-list">
            <div class="prize-desc-item" v-for="(descItem, index) in config.prizeDescList" :key="index"
                 :class="{ 'prize-desc-item-single': index !== 0 }">
              <div class="prize-item-title" @click="pageToDetail(descItem)">{{ descItem.title }}</div>
              <div class="prize-item-date">{{ descItem.date }}</div>
              <div class="desc-symbol">{{ descItem.symbol }}</div>
            </div>
          </div>
        </div>

      </div>
      <!-- 新闻动态 -->
      <div class="news">
        <div class="news-title">{{ config.newsTitle }}</div>
        <div class="news-list">
          <div class="news-item"
               v-for="(item, index) in newsList?.slice((pageNum - 1) * pagesize, pageNum * pagesize)"
               :key="index">
            <div class="news-item-left">
              <div class="news-item-title" @click="pageToDetail(item)">{{ item.title }}</div>
              <div class="news-item-desc">{{ item.info }}</div>
              <div class="news-item-date">{{ item.date }}</div>
            </div>
            <el-image class="news-img" :src="item.src" fit="cover"></el-image>
          </div>
        </div>
        <enoPagination :pageNum="pageNum" :pagesize="pagesize" :total="newsList.length"
                       @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></enoPagination>
      </div>
    </div>
  </div>
</template>

<script>

import enoPagination from '../common/eno_pagination'
import {docHtmlPath, sortCaseByDate} from "@/utils";
import {config} from './service_support_detail'

export default {
  name: "",
  components: {enoPagination},
  data() {
    return {
      config: config,
      pageNum: 1,
      pagesize: 10,
    };
  },
  watch: {},
  computed: {
    newsList() {
      return this.sortCaseByDate(this.config.newsList)
    }
  },
  mounted() { },
  methods: {
    sortCaseByDate,
    goBack() {
      this.$router.go(-1);
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageNum = val
    },
    pageToDetail(item) {
      docHtmlPath({
        ...item,
        source: '服务支持',
      })
    },
  },
};
</script>

<style scoped lang="less">
.content {
  padding: 45px 68px 100px;

  .content-title {
    font-size: 48px;
  }

  .content-desc {
    font-size: 30px;
    margin: 30px 0 100px;
  }

  .prize {
    .prize-title {
      font-size: 30px;
      margin-bottom: 60px;
    }

    .prize-list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 52px;

      .prize-img {
        margin-bottom: 20px;
        height: 300px;
      }

      .prize-item-title {
        margin-bottom: 8px;
        font-size: 20px;
        line-height: 30px;
        height: 60px;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      .prize-item-desc {
        color: @mainGrayColor2;
        margin-bottom: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .desc-symbol {
        margin-top: 20px;
        font-size: 20px;
      }

      .prize-desc-item-single {
        margin-top: 34px;
      }
    }
  }

  .news {
    margin-top: 100px;
    padding: 0 217px;

    .news-title {
      font-size: 30px;
      margin-bottom: 60px;
    }

    .news-list {
      .news-item {
        display: grid;
        grid-template-columns: 4fr 1fr;
        grid-column-gap: 20px;
        padding: 50px 0;
        border-top: 1px solid @mainGrayColor3;

        &:nth-last-child(2),
        &:last-child {
          border-bottom: 1px solid @mainGrayColor3;
        }

        .news-item-left {
          .news-item-title {
            font-size: 20px;
            line-height: 30px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }

          .news-item-desc {
            margin: 8px 0 20px;
            color: @mainGrayColor2;
            line-height: 27px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }

        .news-img {
          width: 210px;
          height: 150px;
        }
      }
    }
  }
}

.new-detail {
  padding-bottom: 20px;

  .detail-back {
    display: flex;
    align-items: center;

    .el-icon-back {
      font-size: 24px;
      cursor: pointer;
    }

    .detail-text {
      margin: 0 10px;
      font-size: 24px;
    }
  }
}


@media @mobile {
  .content {
    padding: 20px 16px 60px;

    .content-title {
      font-size: 28px;
      line-height: 1.3;
    }

    .content-desc {
      font-size: 18px;
      margin: 20px 0 0 0;
      line-height: 1.5;
    }

    .prize {
      .prize-title {
        font-size: 22px;
        margin-bottom: 30px;
      }

      .prize-list {
        grid-template-columns: 1fr;
        grid-column-gap: 0;
        grid-row-gap: 30px;

        .prize-img {
          margin-bottom: 16px;
          height: auto;
          width: 100%;
        }

        .prize-item-title {
          margin-bottom: 6px;
          font-size: 18px;
          line-height: 26px;
          height: auto;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .prize-item-desc {
          margin-bottom: 16px;
          font-size: 14px;
          line-height: 22px;
        }

        .desc-symbol {
          margin-top: 16px;
          font-size: 18px;
        }

        .prize-desc-item-single {
          margin-top: 20px;
        }
      }
    }

    .news {
      margin-top: 40px;
      padding: 0;

      .news-title {
        font-size: 22px;
        margin-bottom: 30px;
      }

      .news-list {
        .news-item {
          grid-template-columns: 1fr;
          grid-column-gap: 0;
          grid-row-gap: 16px;
          padding: 20px 0;

          .news-item-left {
            order: 2;

            .news-item-title {
              font-size: 18px;
              line-height: 26px;
            }

            .news-item-desc {
              margin: 6px 0 16px;
              font-size: 14px;
              line-height: 22px;
            }
          }

          .news-img {
            order: 1;
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }

  .new-detail {
    padding-bottom: 16px;

    .detail-back {
      .el-icon-back {
        font-size: 20px;
      }

      .detail-text {
        margin: 0 8px;
        font-size: 20px;
      }
    }
  }
}
</style>